import type { SessionInvoiceParams } from "@/invoice/session-invoice"
import { create } from "zustand"

interface SessionInvoiceState {
  params: SessionInvoiceParams | null
  setSessionInvoice: (params: SessionInvoiceParams) => void
  clearSessionInvoice: () => void
}

const useSessionInvoiceStore = create<SessionInvoiceState>((set) => ({
  params: null,
  setSessionInvoice: (params) => set({ params }),
  clearSessionInvoice: () => set({ params: null }),
}))

function hasSessionInvoice(): boolean {
  return useSessionInvoiceStore.getState().params !== null
}

function getSessionInvoiceParams(): SessionInvoiceParams | null {
  return useSessionInvoiceStore.getState().params
}

export { useSessionInvoiceStore, hasSessionInvoice, getSessionInvoiceParams }
